module.exports = __webpack_public_path__ + "static/img/7.c059c57.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/sp/7.png
// module id = jTkt
// module chunks = 0